import React, { useEffect, useRef } from 'react';
import { isTauri } from '@tauri-apps/api/core';
import { updateService } from '../services/updateService';

export function AutoUpdater(): null {
  const startedRef = useRef(false);

  useEffect(() => {
    if (!isTauri() || startedRef.current) return;
    startedRef.current = true;

    const timer = window.setTimeout(() => {
      void updateService.checkForUpdates({ background: true });
    }, 3000);

    return () => window.clearTimeout(timer);
  }, []);

  return null;
}
